import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import Popup from "../Helpers/Popup";
import ErrorRows from "./ErrorRows";

function ImportResult(props) {
  const store = useLocalObservable(() => ({
    show_error_rows:false
  }));
  const compStore = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  if(compStore.submit_result === null) {
    return null;
  }

  if(compStore.submit_result.answer === false) {
    return (
      <div className="tar const1">
        {!compStore.submit_result.errors || compStore.submit_result.errors.lengt == 0?(
          <div className="const1">Ошибка!</div>
        ):null}
        {compStore.submit_result.errors?(
          <div>
            {compStore.submit_result.errors.map((item)=>{
              return (
                <div>{item.str}</div>
              )
            })}
          </div>
        ):null}

      </div>
    )
  }

  return (
    <div className="">
      <div className="sc1">
        Обновлено: {compStore.submit_result.answer.updated}
      </div>
      <div className="pc1">
        Добавлено: {compStore.submit_result.answer.inserted}
      </div>
      <div className="const1">
        Ошибок: {compStore.submit_result.answer.errors}
      </div>
      {compStore.submit_result.answer.error_rows.length?(
        <span className="pointer pc1 underline" onClick={()=>{
          runInAction(()=>{
            store.show_error_rows=true;
          });
        }}>Показать строки с ошибками</span>
      ):null}
      <Popup disablePaddings={true} showed={store.show_error_rows} onHide={()=>{ runInAction(()=>{ store.show_error_rows=false; }); }}>
        <div style={{width: 1000}}  className="pr bg-w1">
          <ErrorRows />
        </div>
      </Popup>
    </div>
  )
};

ImportResult.defaultProps = {};

ImportResult.propTypes = {}

export default observer(ImportResult);
